import React,{useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import { useGrade } from '../../../context/GradeContext';
import { useStudentsData } from '../../../context/StudentsContext';
import { Modal, Button, Spinner } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSerializeDetail } from '../../../store/actions/serializeDetailActions';
import { assignRollNo } from '../../../store/actions/RollNoUpdateActions';
import Swal from 'sweetalert2';

const RollAssignment = () => {

    const dispatch = useDispatch();
    const { loadingsd, students, error } = useSelector((state) => state.serializeDetail);

    const [studentId, setStudentId] = useState('');
    const [rollNo, setRollNo] = useState('');
  
    // get fee structures 
    const { currentYearData, loading, refreshData } = useStudentsData(); 
    // console.log(currentYearData);
    // modals 
    const [allotmentModal, setAllotmentModal] = useState(false);
    const [editModal, setEditModal] = useState(false);

    //store serialize data
    const [serialzed, setSerialzed] = useState({});

      //select student detail
    const [detail, setDetail] = useState({});
    const closeAllotment = () => setAllotmentModal(false);
    const openAllotment = (student_id) => {
        setStudentId(student_id);
        if(students !== undefined){
            const student = students.filter(single => single.student_id === student_id)
            setSerialzed(student[0]);
        }
        const singleDetail = currentYearData.filter(student => student.student_id === student_id)
        setDetail(singleDetail[0]);
        setAllotmentModal(true)
    };

    const closeEditModal = () => setEditModal(false);
    const openEditModal = () => setEditModal(true);

    // Handler to update the rollNo state
    const handleRollNoChange = (event) => {
        setRollNo(event.target.value);
    };

    // Handle cancel button
    const handleCancel = () => {
        setRollNo('');
        closeAllotment();
    };

    //Classes
    const { grade } = useGrade();
    
    //For Class or Grade Selection
    const [selectedGrade, setSelectedGrade] = useState('--Select--');
    const [displayList, setDisplayList] = useState(currentYearData);

    useEffect(() => {
        dispatch(fetchSerializeDetail(selectedGrade)); // Fetch for the selected class
    }, [dispatch, selectedGrade]);

    const handleSubmit = (e) => {
        e.preventDefault();
      
        // Dispatch the action to assign the roll number
        dispatch(assignRollNo(studentId, rollNo))
          .then(() => {
            // If the dispatch is successful, show a success alert
            Swal.fire({
              title: 'Success!',
              text: 'Roll No Assigned Successfully!',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              // Close the modal here (assuming you have a function like `closeModal`)
              closeAllotment();
              refreshData();
              setRollNo('')
            });
          })
          .catch(() => {
            // Show an error alert if the dispatch fails
            Swal.fire({
              title: 'Error!',
              text: 'Roll No Assignment Failed!',
              icon: 'error',
              confirmButtonText: 'Try Again'
            });
          });
      };
    

     // Search 
     const [searchTerm, setSearchTerm] = useState('');

    const filteredData = Array.isArray(currentYearData) ? currentYearData.filter(item => {
        const searchTermLower = searchTerm.toLowerCase();
        return (
            (!selectedGrade || item.class_admitted === selectedGrade) &&
            (
                item.full_name.toLowerCase().includes(searchTermLower) ||
                item.student_uid.toString().includes(searchTermLower)
            )
        );
    }) : [];

    const recordsPage = 10;
    const [currentPage , setCurrentPage] = useState(1);
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;  
    let records = 0;
    let npage = 0;
    if(displayList.length > 0 && filteredData.length === 0){
        records = displayList.slice(firstIndex, lastIndex);
        npage = Math.ceil(displayList.length / recordsPage);
    }else{
        records = filteredData.slice(firstIndex, lastIndex);
        npage = Math.ceil(filteredData.length / recordsPage);
    }
    const number = [...Array(npage + 1).keys()].slice(1)
    

    const selectOption = (e) => {
        setSelectedGrade(e.target.value);
    }

    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleRefresh = () => {
        refreshData();
    };

    function prePage (){
        if(currentPage !== 1){
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage (student_id){
        setCurrentPage(student_id);
    }
    
    function nextPage (){
        if(currentPage !== npage){
            setCurrentPage(currentPage + 1)
        }
    }  

  return (
    <>
        <div className="row">
                <div className="col-xl-12">                    
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-title flex-wrap">
                                <div className="input-group search-area mb-md-0 mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={handleChange}
                                    />
                                    <span className="input-group-text"><Link to={"#"}>
                                        <svg wstudent_idth="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF"/>
                                        </svg>
                                    </Link></span>
                                </div>
                                <div className='d-flex'>
                                    <Form.Select size="sm" style={{width:'120px'}} value={selectedGrade} onChange={selectOption}>
                                        {/* <option value="all">---All---</option> */}
                                        {grade.map((item, index) => 
                                            <option value={item.class_options} key={index}>{item.class_label}</option>
                                        )}
                                    </Form.Select>
                                    <span className='p-2'></span>
                                    <button className='btn btn-success' onClick={handleRefresh} disabled={loading}>
                                        Refresh Data
                                    </button>
                                </div>
                            </div>
                        </div> 
                                       
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data pb-50">
                                <div student_id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab dataTable no-footer" student_id="example-student">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>ID</th>
                                                <th>Date</th>
                                                <th>Grade</th>
                                                <th>Roll No</th>                                                
                                                <th className="text-start">Action</th>
                                            </tr>
                                        </thead>
                                        {records.length >0
                                            ?(
                                                <tbody>
                                                    {records.map((item, ind)=>(                                
                                                        <tr key={ind}>
                                                            <td>
                                                                <div className="trans-list">
                                                                    <img src={item.pass_photo} alt="" className="avatar avatar-sm me-3" />
                                                                    <h4>{item.full_name}</h4>
                                                                </div>
                                                            </td>
                                                            <td><span className="text-primary font-w600">ID {item.student_uid}</span></td>
                                                            <td>
                                                                <div className="date">{item.admitted_on.slice(0,10)}</div>
                                                            </td>
                                                            <td>
                                                                <div className={`badge bg-${item.class_admitted === 'VII A' ? 'secondary' : item.class_admitted === 'XII A' ? 'primary' : 'warning'}`}>
                                                                    {item.class_admitted}
                                                                </div>
                                                            </td>
                                                           <td>
                                                                <div>{item.roll_no === 0 ?'Not Alloted': item.roll_no}</div>
                                                            </td>
                                                           <td>
                                                                <div className="d-flex">
                                                                <div className="icon-box icon-box-sm bg-light me-1">
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" variant="primary" onClick={() =>openAllotment(item.student_id)}>
                                                                    <rect x="2" y="2" width="20" height="20" rx="4" fill="#4CAF50" />
                                                                    <path d="M9 12.5L11.5 15L15.5 9.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </div>
                                                                <div className="icon-box icon-box-sm bg-light">
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" variant="primary" onClick={() =>openEditModal(item.ind)}>
                                                                    <path d="M3 21V17.25L14.81 5.44C14.9005 5.34953 15.004 5.27589 15.1156 5.22356C15.2273 5.17122 15.3456 5.14134 15.4667 5.13513C15.5879 5.12892 15.7091 5.14647 15.8234 5.18673C15.9377 5.22699 16.0423 5.28914 16.1315 5.36999L18.63 7.87C18.7109 7.95918 18.773 8.06381 18.8133 8.17814C18.8536 8.29247 18.8712 8.41366 18.865 8.53485C18.8588 8.65603 18.8289 8.77433 18.7766 8.88602C18.7243 8.99771 18.6507 9.10121 18.56 9.19L6.75 21H3ZM21 7.41L16.59 3L18 1.59C18.3702 1.21923 18.8891 1.00032 19.43 1.00032C19.9709 1.00032 20.4898 1.21923 20.86 1.59L22.41 3.14C22.7808 3.51023 22.9997 4.02909 22.9997 4.57C22.9997 5.11091 22.7808 5.62977 22.41 6L21 7.41Z" fill="#000000"/>
                                                                    </svg>
                                                                </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                     <tr>
                                                        <td colSpan="8" style={{ height: "140px" }}></td>
                                                    </tr>
                                                </tbody>
                                            )
                                            :'No data yet'
                                        }                                        
                                    </table> 
                                    <div className="d-sm-flex text-center justify-content-between align-items-center">                           
                                        <div className='dataTables_info'>
                                            Showing {lastIndex-recordsPage + 1} to{" "}
                                            {currentYearData.length < lastIndex ? currentYearData.length : lastIndex}
                                            {" "}of {currentYearData.length} entries
                                        </div>
                                        <div
                                            className="dataTables_paginate paging_simple_numbers justify-content-center"
                                            id="example-student_wrapper"
                                        >
                                            <Link
                                                className="paginate_button previous disabled"
                                                to="#"                                        
                                                onClick={prePage}
                                            >
                                                <i className="fa-solid fa-angle-left" />
                                            </Link>
                                            <span>                                      
                                                {number.map((n , i )=>(
                                                    <Link className={`paginate_button ${currentPage === n ? 'current' :  '' } `} key={i}                                            
                                                        onClick={()=>changeCPage(n)}
                                                    > 
                                                        {n}                                                

                                                    </Link>
                                                ))}
                                            </span>
                                            <Link
                                                className="paginate_button next"
                                                to="#"                                        
                                                onClick={nextPage}
                                            >
                                                <i className="fa-solid fa-angle-right" />
                                            </Link>
                                        </div>
                                    </div>             
                                </div>
                            </div>  
                        </div> 
                    </div>    
                </div>    
            </div>  
            {/* Roll Allotment Modal  */}
            <Modal show={allotmentModal} onHide={handleCancel} animation={false}>
                <Modal.Header closeButton>
                <Modal.Title>Roll No. Allotment Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>Admission Serial No (Classwise) is: {serialzed.serial_number}</h3>
                    
                    {detail !==''
                        ?(
                            <div className="container">
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="fullName" className="form-label">Full Name</label>
                                        <input
                                        type="text"
                                        className="form-control"
                                        id="fullName"
                                        value={detail.full_name} 
                                        readOnly
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="class" className="form-label">Class</label>
                                        <input
                                        type="text"
                                        className="form-control"
                                        id="class_admitted"
                                        value={detail.class_admitted}  
                                        readOnly
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="uid" className="form-label">UID</label>
                                        <input
                                        type="text"
                                        className="form-control"
                                        id="student_uid"
                                        value={detail.student_uid}  
                                        readOnly
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="date" className="form-label">Admission Date</label>
                                        <input
                                        type="date"
                                        className="form-control"
                                        id="admitted_on"
                                        value={detail.admitted_on ? new Date(detail.admitted_on).toISOString().split('T')[0] : ''} 
                                        readOnly
                                        />
                                    </div>
                                </div>

                                {/* Third Row: Enter Roll No (editable) */}
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        <label htmlFor="rollNo" className="form-label">Enter Roll No</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="rollNo"
                                            value={rollNo}
                                            onChange={handleRollNoChange}
                                            placeholder="Enter Roll No"
                                        />
                                    </div>
                                </div>
                            </div>                          
                        )
                        :'Loading...'
                 }

                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Save Changes
                </Button>
                </Modal.Footer>
            </Modal>
            
            {/* edit modal  */}
            <Modal show={editModal} onHide={closeEditModal} animation={false}>
                <Modal.Header closeButton>
                <Modal.Title>Edit Roll No. Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>Roll No</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={closeEditModal}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={closeEditModal}>
                    Save Changes
                </Button>
                </Modal.Footer>
            </Modal>
        </>
  )
}

export default RollAssignment
